import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { IconButton, TableHead, TableRow, TableCell, Checkbox } from '@mui/material';
import { makeStyles } from '@mui/styles';
import BuildIcon from '@mui/icons-material/Build';
import { formChange } from '../../../../reducers/form';
import PopperColumnType from './PopperColumnType'
import PopperColumnVisible from './PopperColumnVisible'
import classNames from 'classnames';
import { createSelector } from 'reselect';

const useStyles = makeStyles((theme) => ({
  cell: {
    minWidth: 120,
    backgroundColor: theme.palette.grey[300],
    fontWeight: 700,
    cursor: 'pointer'
  },
  row: {
    backgroundColor: theme.palette.grey[400]
  },
  titleOK: {
    color: theme.palette.success.main
  }
}));

export default function TableHeader({ formName }) {
  const classes = useStyles();
  const column = useSelector(state => state.form[formName]?.values.column)
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectKey, setSelectKey] = useState(null)
  const handleClick = (key, currentTarget) => {
    setSelectKey(key)
    setAnchorEl(currentTarget)
  };
  return <TableHead>
    <PopperColumnType anchorEl={anchorEl} onClose={() => setAnchorEl(null)} column={column} formName={formName} selectKey={selectKey} />
    <TableRow className={classes.row}>
      <CheckboxCell formName={formName} classes={classes} />
      {Object
        .keys(column)
        .filter(key => column[key].visible)
        .map(key => {
          const obj = column[key];
          return <TableCell
            key={key}
            onClick={(e) => { handleClick(key, e.currentTarget) }}
            align='center'
            className={classNames(classes.cell, {
              [classes.titleOK]: obj.select !== '',
            })}
          >
            {(obj.select === '') ? key : obj.selectName}
          </TableCell>
        })}
    </TableRow>
  </TableHead>
}
const makeSelectTableHeadStatus = createSelector(
  [
    (state, formName) => state.formTable[formName]?.allIds,
    (state, formName) => state.form[formName]?.values.selectId,
  ],
  (allIds, selectId) => {
    if (!allIds?.length) return { isAllSelected: false, isIndeterminate: false };
    const isAllSelected = allIds.length > 0 && selectId.length === allIds.length;
    const isIndeterminate = selectId.length > 0 && selectId.length < allIds.length
    return { isAllSelected, isIndeterminate };
  }
);

function CheckboxCell({ formName, classes }) {
  const { isAllSelected, isIndeterminate } = useSelector(state => makeSelectTableHeadStatus(state, formName))
  const dispatch = useDispatch()
  const [anchorList, setAnchorList] = useState(null)
  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    dispatch((disp, getState) => {
      const state = getState()
      const allIds = state.formTable[formName].allIds || []
      disp(formChange(isChecked ? allIds : [], { field: 'selectId', name: formName }));
    })
  }
  return <TableCell padding="checkbox" className={classes.cell} >
    <PopperColumnVisible anchorList={anchorList} onClose={() => setAnchorList(null)} formName={formName} />
    <Checkbox
      checked={isAllSelected}
      indeterminate={isIndeterminate}
      onChange={handleCheckboxChange}
    />
    <IconButton size='small' onClick={(e) => { setAnchorList(e.currentTarget) }}>
      <BuildIcon fontSize='small' />
    </IconButton>
  </TableCell>
}